import useConsumptionOrMagnituteFilterStore, {
  CONSUMPTION_OR_MAGNITUDE_FILTERS
} from "../stores/useConsumptionOrMagnituteFilterStore";

const useIsMagnituteFilterOn = () => {
  const {
    activeConsumptionOrMagnituteFilter
  } = useConsumptionOrMagnituteFilterStore();

  return (
    activeConsumptionOrMagnituteFilter ===
    CONSUMPTION_OR_MAGNITUDE_FILTERS.MAGNITUDE
  );
};

export default useIsMagnituteFilterOn;
